var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "open_menu",
    className: "st0",
    d: "M6,36v-3h36v3H6z M6,25.5v-3h36v3H6z M6,15v-3h36v3H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "exit_menu",
    className: "st0",
    d: "M10.3,12.3l2.1-2.1l25.5,25.5l-2.1,2.1L10.3,12.3z M12.3,37.8l-2.1-2.1l25.5-25.5l2.1,2.1L12.3,37.8z",
    visibility: "hidden"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.a24a4cfe82cab6918b9539d5b49c4786.svg";
export { ForwardRef as ReactComponent };